/* eslint-disable @steelbrain/consistent-modules/default-import-match-filename, import/no-unresolved */
import logger, { identifyUser } from '@@proxy-internal-logger'
// NOTE: This is a stub file. The imports to @/utils/logger are rewritten through next.js
// to be the @/client/utils/logger or @/server/utils/logger based on the runtime.

export { identifyUser }
export default logger
